'use client';

import { useLingui } from '@lingui/react';
import { Bets } from '../Bets';
import { Brands } from '../Brands';
import { CardTitle } from '../Shares/CardTitle';
import { CarouselImageItem } from '../Shares/CarouselImageItem';
import { CarouselLayout } from '../Shares/CarouselLayout';
import { games } from '../Shares/games';
import { GameControl } from './GameControl';
import { GameIntro } from './GameIntro';
import { GameView } from './GameView';
import { ShareModal } from './ShareModal';
export const GameTemplate: React.FC = () => {
  const lives = games.find(item => item.id === 'lives');
  const {
    i18n
  } = useLingui();
  return <>
      <GameView />
      <GameControl />
      <GameIntro />
      <CarouselLayout my={20} id="live" title={<CardTitle firstText={i18n._('Live games')} isFirstGradient colorFrom="#F5FF6B" colorTo="#FF2A7F" iconUrl="/assets/title-icons/5.png" mt={6} />} items={lives?.items ?? []} slideSize={{
      base: '33.33%',
      sm: '20%',
      md: '20%',
      lg: '16%'
    }} isShadow>
        {lives?.items.map(item => <CarouselImageItem key={item.id} id={item.id} imgCard={item.imgCard} mobileWidth={128 / 135} desktopWidth={118 / 127} />)}
      </CarouselLayout>
      <Brands />
      <Bets hasActionTab />
      <ShareModal />
    </>;
};